import Main from './Main'
import Lista from './components/AtendentePatioLista'
import Novo from './components/NovoAtendentePatio'

export default [
  {
    path: 'atendente-patio',
    name: 'policiacivil.sistema.atendente-patio',
    component: Main,
    redirect: { name: 'policiacivil.sistema.atendente-patio.list' },
    children: [
      {
        path: '/',
        name: 'policiacivil.sistema.atendente-patio.list',
        component: Lista
      },
      {
        path: 'registro',
        name: 'policiacivil.sistema.atendente-patio.novo',
        component: Novo
      },
      {
        path: ':id',
        name: 'policiacivil.sistema.atendente-patio.edit',
        component: Novo
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/app/policia-civil/sistema/atendente-patio/routes.js